// 根据用户状态过滤 0：全部成员 1：管理员 2：成员 3：申请加入 4：退出成员 
export enum CompanyMemberListStatusEnum {
    All = 0,
    Admin = 1,
    Member = 2,
    Apply = 3,
    Quit = 4
}

// 根据用户状态过滤 0：全部成员 1：管理员 2：编辑成员 3：普通成员 4：申请加入 5：已退出成员
export enum CompnayProductMemberStatusEnum {
    All = 0,
    Admin = 1,
    Editor = 2,
    Member = 3,
    Apply = 4,
    Quit = 5
}

// 状态 0：已申请 1：已加入 2：未通过申请 3：已退出 4：冻结中
export enum CompnayMemberStatusEnum {
    Applied = 0,
    Joined = 1,
    NotApproved = 2,
    Quit = 3,
    Frozen = 4
}

// 企业成员列表返回数据
export interface CompanyMember {
    /**
     * 来源类型
     */
    applyType?: number;
    /**
     * 企业ID
     */
    archiveRole: number | null;
    enterpriseId: number;
    /**
     * 企业名称
     */
    enterpriseName: string;
    /**
     * 成员ID
     */
    id: number;
    /**
     * 申请ID
     */
    applyId?: number;
    /**
     * 加入时间
     */
    joinTime?: Date;
    /**
     * 来源
     */
    joinWay?: string;
    /**
     * 能量点限制总量
     */
    limitAmount: number;
    /**
     * 能量点限制规则 -1：默认，等同于不限制 0：不限制 1：月消耗限制 2：分配能量点
     */
    limitType: number;
    oneselfFlag?: boolean
    /**
     * 微信昵称
     */
    name: string;
    /**
     * 拥有的权限 1：管理知识库 2：创建产品
     */
    permissions?: number[];
    /**
     * 手机号码（后端脱敏）
     */
    phone: string;
    /**
     * 企业角色 0：普通角色 1：管理员
     */
    role: number;
    /**
     * 状态 0：已申请 1：已加入 2：未通过申请 3：已退出 4：冻结中
     */
    status: CompnayMemberStatusEnum
    /**
     * 总消耗企业能量点
     */
    totalConsumeAmount?: number;
    [property: string]: any;
}
export interface CompanyMemberListModel {
    current?: number;
    pages?: number;
    records: CompanyMember[];
    size?: number;
    total: number;
    [property: string]: any;
}

// 企业邀请链接时效性 0：永久 1：1天 2：7天 3：14天
export enum CompanyInviteLinkAgeLimitEnum {
    Permanent = 0,
    OneDay = 1,
    SevenDay = 2,
    FourteenDay = 3
}

// 核销邀请加入返回码 0：无效邀请码 1：成功加入 2：企业准入审批中 3：产品准入审批中 4：申请失败 5：非企业成员(需先申请先加入企业)
export enum CompanyInviteLinkVerifyCodeEnum {
    Invalid = 0,
    Success = 1,
    EnterpriseApproving = 2,
    ProductApproving = 3,
    ApplyFailed = 4,
    NotCompanyMember = 5
}

export interface CompanyEnergyPointListItem {
    changeAmount: number,
    changeBy: string,
    expiredTime: string,
    changeTime: string,
    changeType: string,
    changeReason: string,
}


// 企业产品列表返回数据
export interface CompanyProductModel {
    current?: number;
    pages?: number;
    records: CompanyProduct[];
    size?: number;
    total: number;
    [property: string]: any;
}

export interface CompanyProduct {
    /**
     * 申请状态 -1：未申请 0：已申请，未审核
     */
    applyStatus?: number;
    /**
     * 企业档案产品ID
     */
    archiveId?: number;
    /**
     * 企业档案产品名称
     */
    archiveName?: string;
    /**
     * 企业档案产品品类，多个使用英文逗号隔开
     */
    categories?: string;
    /**
     * 企业档案产品创建时间
     */
    createTime?: string;
    /**
     * 企业档案产品创建人
     */
    creatorName?: string;
    /**
     * 标志 0：企业 1：个人管理 2：参与
     */
    flag?: number;
    /**
     * 图片地址
     */
    imageUrl?: string;
    /**
     * 企业档案产品内的产品的最后一次更新时间
     */
    lastUpdateTime?: string;
    /**
     * 企业档案产品成员信息
     */
    members: CompanyProductMember[];
    [property: string]: any;
}

export interface CompanyProductMember {
    /**
     * 协作ID
     */
    cooperateId?: number;
    /**
     * 创建时间
     */
    createTime?: Date;
    /**
     * 用户头像
     */
    headerImg?: string;
    /**
     * 用户名
     */
    name?: string;
    /**
     * 角色信息 0：管理员 1：编辑成员 2：普通成员
     */
    role?: number;
    /**
     * 用户ID
     */
    userId?: number;
    [property: string]: any;
}


export interface CompanyProductDetil {
    /**
     * 品类
     */
    categories: string[];
    /**
     * 企业档案产品创建时间
     */
    createTime?: Date;
    /**
     * 创建人
     */
    creator?: string;
    /**
     * 企业ID
     */
    enterpriseId: number;
    /**
     * 产品档案ID
     */
    id: number;
    /**
     * 图片地址
     */
    imageUrl?: string;
    /**
     * 企业档案产品内的产品的最后一次更新时间
     */
    lastUpdateTime?: Date;
    /**
     * 产品名称
     */
    name?: string;
    /**
     * 卖点
     */
    sellingPoints: string[];
    /**
     * 产品类型 0：单品 1：系列
     */
    type?: number;
    [property: string]: any;
}


